export enum QuestionDomainNumEnum {
  Knowledge = 10,
  Attitude = 20,
  Behavioral = 30,
  General = 40,
  SelfAssessment = 50,
  OtherAssessment = 60,
}
